export const mapKycDocument = (filledData = {}, formData = {}) => {
  const docKeys = [
    "certificateofIncorporation",
    "memorandumofAssociation",
    "articlesofAssociation",
    "powerofAttorney",
    "copyofPANAllotment",
    "copyofTelephoneBill",
    "gstRegistrationCopy",
    "balanceSheet",
  ];

  const kyc = {};

  docKeys.forEach((key) => {
    const fromFormData = formData?.kycDocument?.[key]?.fileId ?? null;

    const fromFilled =
      filledData?.[`${key}FileId`] ??
      filledData?.[`${key}_fileId`] ??
      null;

    const fileId = fromFormData || fromFilled || null;

    // ⭐ only add key if fileId exists
    if (fileId) {
      kyc[key] = { fileId };
    }
  });

  return { kycDocument: kyc };
};

// mapKycDocumentGet.js

export const DOCUMENT_FIELDS = [
  "certificateofIncorporation",
  "memorandumofAssociation",
  "articlesofAssociation",
  "powerofAttorney",
  "copyofPANAllotment",
  "copyofTelephoneBill",
  "gstRegistrationCopy",
  "balanceSheet",
];

// Map GET API → UI format
export const mapKycDocumentGet = (apiData = {}) => {
  const result = {};

  DOCUMENT_FIELDS.forEach((field) => {
    const doc = apiData[field];

    if (doc && typeof doc === "object") {
      // 🟢 valid document
      result[field] = {
        id: doc.id ?? null,
        fileName: doc.fileName ?? null,
        filePath: doc.filePath ?? null,
      };
    } else {
      // 🔴 empty/null → return default empty
      result[field] = {
        id: null,
        fileName: null,
        filePath: null,
      };
    }
  });

  return {
    kycDocument: result,
  };
};
export const docKeys = [
  "certificateofIncorporation",
  "memorandumofAssociation",
  "articlesofAssociation",
  "powerofAttorney",
  "copyofPANAllotment",
  "copyofTelephoneBill",
  "gstRegistrationCopy",
  "balanceSheet",
];

export const mapKycCheckboxValues = (apiData = {}) => {
  const mapped = {};

  docKeys.forEach((key) => {
    const value = apiData[key];
    mapped[key] = !!(value && value.fileName); // checkbox = true if file exists
  });

  return mapped;
};
